import React from 'react';
import { Box, Container } from '@mui/material';
import PageHeader from './page-header';
import PageContainer from './pageContainer';

interface ListPageLayoutProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: Array<{ label: string; href?: string }>;
  filters?: React.ReactNode;
  children: React.ReactNode;
}

export default function ListPageLayout({
  title,
  subtitle,
  breadcrumbs,
  filters,
  children,
}: ListPageLayoutProps) {
  return (
    <PageContainer>
      <Container maxWidth="xl">
        <PageHeader title={title} subtitle={subtitle} breadcrumbs={breadcrumbs} />

        {filters && (
          <Box sx={{ mb: 4 }}>
            {filters}
          </Box>
        )}

        <Box>{children}</Box>
      </Container>
    </PageContainer>
  );
}
